import { getRegisterFunction } from '../../utils/register.js';
import { OneUxTabpanelNextElement } from './OneUxTabpanelNextElement.js';
export const register = getRegisterFunction(OneUxTabpanelNextElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-tabpanel-next': OneUxTabpanelNextElement;
    "tabpanel-next-02367723821ed19d9f9bd71086680af5": OneUxTabpanelNextElement;
  }
}